module.exports = __webpack_public_path__ + "static/img/act_action.01090af3.png";